function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,87.45098%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 4.050781 4.050781 L 25.949219 4.050781 L 25.949219 25.949219 L 4.050781 25.949219 Z M 4.050781 4.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.808594 22.351562 L 11.484375 21.335938 C 11.808594 21.914062 12.101562 22.390625 12.804688 22.390625 C 13.484375 22.390625 13.910156 22.128906 13.910156 21.09375 L 13.910156 14.105469 L 15.964844 14.105469 L 15.964844 21.132812 C 15.964844 23.261719 14.71875 24.234375 12.894531 24.234375 C 11.25 24.234375 10.296875 23.382812 9.808594 22.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.085938 22.128906 L 18.761719 21.15625 C 19.207031 21.875 19.773438 22.40625 20.789062 22.40625 C 21.644531 22.40625 22.1875 21.976562 22.1875 21.390625 C 22.1875 20.683594 21.628906 20.433594 20.6875 20.023438 L 20.171875 19.800781 C 18.691406 19.167969 17.699219 18.371094 17.699219 16.699219 C 17.699219 15.15625 18.875 13.980469 20.710938 13.980469 C 22.019531 13.980469 22.960938 14.4375 23.640625 15.625 L 22.039062 16.648438 C 21.683594 16.019531 21.304688 15.769531 20.71875 15.769531 C 20.117188 15.769531 19.734375 16.152344 19.734375 16.648438 C 19.734375 17.269531 20.117188 17.519531 21 17.898438 L 21.515625 18.121094 C 23.269531 18.871094 24.25 19.632812 24.25 21.355469 C 24.25 23.207031 22.792969 24.222656 20.84375 24.222656 C 18.925781 24.234375 17.6875 23.320312 17.085938 22.128906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.bdc102dd31e3b6b5385065a77acec01d.svg";
export { ForwardRef as ReactComponent };